export default {
  ADS_VISITED: 'ads_visited',
  ADS_KOS: 'ads_kos',
  INCOMING_CHAT: 'incoming_chat',
  SURVEY_SUBMISSION: 'survey_submission',
  BOOKING_SUBMISSION: 'booking_submission',
  PAID_BOOKING_SUBMISSION: 'paid_booking_submission',
  PROMO: 'promo',
};
